// @flow

import { type Surface } from 'app/common/react/components/PinRep/core/PinRepConfiguration';

export const shoppingPriceIndicatorSurfaces = [
  'BrioCloseupRelatedProducts',
  'CloseupRelatedProducts',
  'ProductPinsFeed',
  'RelatedProductsFeed',
  'ShoppingPackageItem',
  'STLProductsFeed',
  'UpdatedCloseupRelatedProducts',
];

type BuildSecondaryContentPropsArgs = {|
  allowProductCarousel?: boolean,
  surface: Surface,
|};

export type BuildSecondaryContentPropsOutput = {|
  allowProductCarousel: boolean,
  allowShoppingPriceIndicator: boolean,
|};

// This function takes _descriptive_ props and outputs _imperative_ props describing the PinRep SecondaryContent.
// It does not handle what specific pin data values we show. SecondaryContent can handle that.
export default function buildSecondaryContentProps({
  allowProductCarousel = false,
  surface,
}: BuildSecondaryContentPropsArgs) {
  // Display price indicators for product pins if it's on a shopping surface.
  const allowShoppingPriceIndicator = shoppingPriceIndicatorSurfaces.includes(surface);

  return { allowProductCarousel, allowShoppingPriceIndicator };
}
